import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { PercentPipe } from '@angular/common';
import { DxChartComponent } from 'devextreme-angular';
import { timer, Subscription } from 'rxjs';
import { StatisticsService } from '../../services/analytica/statistics.service';

@Component({
  selector: 'app-spends-type-compared',
  templateUrl: './spends-type-compared.component.html',
  styleUrls: ['./spends-type-compared.component.scss'],
})
export class SpendsTypeComparedComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild('totalspendscharts') chart: DxChartComponent;
  @Input() dataSource: any[];
  @Input() subItem: any;
  @Input() params: any;
  @Input() title = 'Total Spend';
  @Input() subtitle = '(annualized)';
  @Input() size: any;
  @Input() show = true;
  @Output() onGpwSplit = new EventEmitter<any>();
  @Output() onSavingsDiff = new EventEmitter<any>();

  pipe: any = new PercentPipe('en-US');
  subs: Subscription = new Subscription();
  constructor(private statisticsService: StatisticsService) {}

  ngOnInit() {
    this.oberserableTimer();
  }

  ngOnChanges(changes: SimpleChanges) {
    const paramsChange = changes['params'];
    if (paramsChange) {
      this.SpendsByType();
    }
    const subItemChange = changes['subItem'];
    if (subItemChange && this.dataSource) {
      this.calcSpendsByType(this.dataSource, this.subItem);
    }
  }

  SpendsByType() {
    const s = this.statisticsService.getSpendsByType(this.params).subscribe(
      result => {
        if (result.data?.length) {
          this.dataSource = result.data;
          this.dataSource.forEach(item => {
            item['new_value'] = 0;
          });
        } else {
          this.defaultSpendsByType();
        }
        this.getGPW(this.dataSource);
      },
      () => this.defaultSpendsByType(),
    );

    this.subs.add(s);
  }

  defaultSpendsByType() {
    this.dataSource = [
      { account_type: '340B', value: 0, purchased_units: 0 },
      { account_type: 'GPO', value: 0, purchased_units: 0 },
      { account_type: 'WAC', value: 0, purchased_units: 0 },
    ];
  }

  calcSpendsByType(spendsByType: any[], subItem) {
    const i = {
      account_type: 'Total',
      value: 0,
      purchased_units: 0,
      new_value: 0,
    };
    const index = spendsByType.findIndex(x => x.account_type === 'Total');
    if (index !== -1) {
      spendsByType.splice(index, 1);
    }

    spendsByType.forEach(item => {
      // if (item.account_type === '340B') {
      //   this.makeSpendsByType(subItem, item, 'unit_cost_340b', i);
      // }
      // if (item.account_type === 'GPO') {
      //   this.makeSpendsByType(subItem, item, 'unit_cost_gpo', i);
      // }
      if (item.account_type === 'WAC') {
        this.makeSpendsByType(subItem, item, 'unit_cost_wac', i);
      }
    });
    const savingsDiff = i.value - i.new_value;
    this.onSavingsDiff.emit(savingsDiff);
    spendsByType.push(i);
    return spendsByType;
  }

  makeSpendsByType(rowData, item, col, totals) {
    item['new_value'] =
      rowData[col] > 0 ? item.purchased_units * rowData[col] : 0;
    totals.purchased_units += item.purchased_units;
    totals.value += item['value'];
    totals.new_value += item['new_value'];
  }

  getGPW(spendsByType) {
    const total =
      spendsByType[0]['value'] +
      spendsByType[1]['value'] +
      spendsByType[2]['value'];
    const phs =
      Math.round(
        ((spendsByType[0]['value'] / total) * 100 + Number.EPSILON) * 100,
      ) / 100;
    const gpo =
      Math.round(
        ((spendsByType[1]['value'] / total) * 100 + Number.EPSILON) * 100,
      ) / 100;
    const wac =
      Math.round(
        ((spendsByType[2]['value'] / total) * 100 + Number.EPSILON) * 100,
      ) / 100;
    const split = `${gpo || 0}% | ${phs || 0}% | ${wac || 0}%`;
    this.onGpwSplit.emit(split);
  }

  oberserableTimer() {
    const source = timer(7200, 1000);
    const abc = source.subscribe(val => {
      if (this.chart) {
        this.chart.instance.render();
      }
    });
    this.subs.add(abc);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
